import "core-js/fn/array/from";
import options from "conf";
import parser from "./parseConfig";
import { initPlayer, closePlayer } from "./initPlayer";

async function main(userOptions) {
  try {
    const conf = await parser({ ...options, ...userOptions });
    await initPlayer(conf);
  } catch (error) {
    console.error(error);
  }
  return -1;
}
if (options.autolaunch) main();

// eslint-disable-next-line
window.EBPlayer = {
  start: userOptions => {
    if (userOptions && userOptions.vast) {
      if (userOptions.vast.adTagUrl)
        options.plugins.videojs_vast.adTagUrl = userOptions.vast.adTagUrl;
      if (userOptions.vast.more) {
        options.plugins.videojs_vast.adTagUrl = options.plugins.videojs_vast.adTagUrl.concat(
          "&",
          userOptions.vast.more,
        );
        const domain = userOptions.vast.more
          .split("&")
          .map(e => e.split("="))
          .filter(e => e[0] === "domain")[0];
        if (domain && domain[1]) {
          const domains = domain[1].split(",");
          if (domains.every(e => !window.location.hostname.endsWith(e)))
            options.plugins.videojs_vast = undefined;
        }
      }
    }
    if (userOptions && userOptions.src) options.src = userOptions.src;
    if (userOptions && userOptions.token) options.token = userOptions.token;
    if (userOptions && userOptions.css) options.css = userOptions.css;

    main(userOptions);
  },
  close: closePlayer,
};



// WEBPACK FOOTER //
// ./src/js/index.js